module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah Remy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Sarah Remy writes fiction to keep real life from getting out of hand. She lives in Spokane, Washington, where she shows horses, works at a local elementary school, and rehabs her old house.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VNAeFD/tc-custom/9780062383440.jpg?1718044723047",
      "alt": "This image is the cover for the book Across the Long Sea, Bone Magic"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Across the Long Sea, Bone Magic\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("The gripping follow-up to Stonehill Downs")])]), _c('p', [_vm._v("As the most valuable asset in the kingdom of Wilhaiim, Malachi Doyle has many responsibilities—protector, assassin, detective, and King Renault's right-hand man. And until he met Avani in the cursed village of Stonehill Downs, he believed he was the last of his kind: a magus who can communicate with the dead.")]), _c('p', [_vm._v("But Wilhaiim is left vulnerable when Mal and his page, Liam, are kidnapped and ferried across the Long Sea to a warring kingdom in search of its own magus. To make matters worse, a springtime plague is rapidly spreading, and beneath the earth the "), _c('i', [_vm._v("sidhe")]), _vm._v(" are preparing for war. With Mal missing and presumed dead, Avani reluctantly takes his place as Wilhaiim's magus. But her powers are unreliable and untested, her many allies are treacherous, and she is certain Mal is alive. Will she be able to keep Wilhaiim—and herself—safe?")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0